import { ActionTree } from 'vuex'
import { ElectricityInstallationState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<ElectricityInstallationState, RootState> = {
}
